import { TimePicker } from "antd";
import type { TimeRangePickerProps } from "antd";
import { useTranslation } from "react-i18next";
import { cn } from "sipli-fleet-core/utils/cn";

const { RangePicker } = TimePicker;

export interface CustomTimeRangePickerProps extends TimeRangePickerProps {
  className?: string;
}

const CustomTimeRangePicker = ({
  className,
  placeholder,
  ...restProps
}: CustomTimeRangePickerProps) => {
  const { t } = useTranslation();

  return (
    <RangePicker
      className={cn("custom-time-range-picker", className)}
      placeholder={placeholder ?? [t("time_start"), t("time_end")]}
      {...restProps}
    />
  );
};

export default CustomTimeRangePicker;
